export default __webpack_public_path__ + "static/media/missing_info.22c51726.svg";